export const API_BASE = import.meta.env.VITE_API_BASE ?? '';

export const LOGIN_ENDPOINT = '/api/professionals/auth/login';
export const REGISTER_ENDPOINT = '/api/mobile/register';

const config = {
  API_BASE,
  LOGIN_ENDPOINT,
  REGISTER_ENDPOINT,
};
export default config;
